/**
 * Mappe le payload AddProspectModal (legacy ProLead) vers
 * création NR2J Organization + Contact primaire.
 * Ne passe jamais par /admin/pro-leads (SUPER_ADMIN-only).
 */

export function mapProspectModalToOrganization(payload = {}) {
  const businessName = String(payload.businessName || '').trim();
  return {
    commercialStatus: 'PROSPECT',
    pipelineStage: 'NOUVEAU',
    raisonSociale: businessName || null,
    nomCommercial: businessName || null,
    emailPrincipal: payload.email ? String(payload.email).trim() : null,
    telephone: payload.phone ? String(payload.phone).trim() : null,
    ville: payload.city ? String(payload.city).trim() : null,
    commercialNotes: payload.internalNotes
      ? String(payload.internalNotes).trim()
      : (payload.message ? String(payload.message).trim() : null),
    nextFollowUpAt: payload.nextFollowUpAt || null,
    ...(payload.ownerUserId ? { ownerUserId: payload.ownerUserId } : {}),
  };
}

export function mapProspectModalToContact(payload = {}) {
  const fullName = String(payload.name || '').trim();
  if (!fullName) return null;
  const parts = fullName.split(/\s+/).filter(Boolean);
  return {
    prenom: parts[0] || fullName,
    nom: parts.length > 1 ? parts.slice(1).join(' ') : fullName,
    email: payload.email ? String(payload.email).trim() : null,
    telephone: payload.phone ? String(payload.phone).trim() : null,
    isPrimary: true,
  };
}

/**
 * @param {object} apiService
 * @param {object} payload AddProspectModal payload
 * @returns {Promise<{ organization: object, contact: object|null }>}
 */
export async function createNr2jProspectFromModal(apiService, payload) {
  const orgBody = mapProspectModalToOrganization(payload);
  const created = await apiService.createNr2jOrganization(orgBody);
  const organization = created?.organization || created;
  if (!organization?.id) {
    throw new Error('Société créée mais identifiant manquant');
  }
  const contactBody = mapProspectModalToContact(payload);
  let contact = null;
  if (contactBody) {
    try {
      const res = await apiService.createNr2jContact(organization.id, contactBody);
      contact = res?.contact || res;
    } catch {
      // Org créée : contact optionnel — ne pas faire échouer toute la création.
    }
  }
  return { organization, contact };
}
